import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useProjectStore = create(
  persist(
    (set, get) => ({
      projects: [],
      selectedProject: null,
      isLoading: false,
      error: null,

      setProjects: (projects) =>
        set((state) => {
          // Actualizar selectedProject con datos frescos del servidor
          const updatedSelectedProject = state.selectedProject
            ? projects.find((p) => p.id === state.selectedProject.id) || null
            : null;
          return {
            projects,
            selectedProject: updatedSelectedProject,
          };
        }),

      setSelectedProject: (project) => set({ selectedProject: project }),

      selectProjectById: (projectId) => {
        const { projects } = get();
        const project = projects.find((p) => p.id === projectId);
        if (project) {
          set({ selectedProject: project });
        }
      },

      addProject: (project) =>
        set((state) => ({
          projects: [...state.projects, project],
        })),

      updateProject: (projectId, updates) =>
        set((state) => ({
          projects: state.projects.map((p) => (p.id === projectId ? { ...p, ...updates } : p)),
          selectedProject:
            state.selectedProject?.id === projectId
              ? { ...state.selectedProject, ...updates }
              : state.selectedProject,
        })),

      deleteProject: (projectId) =>
        set((state) => ({
          projects: state.projects.filter((p) => p.id !== projectId),
          selectedProject:
            state.selectedProject?.id === projectId ? null : state.selectedProject,
        })),

      setLoading: (isLoading) => set({ isLoading }),

      setError: (error) => set({ error }),

      clearError: () => set({ error: null }),
    }),
    {
      name: 'agileflow-project',
      partialize: (state) => ({
        selectedProject: state.selectedProject,
      }),
    }
  )
);

export default useProjectStore;
